<template>
    <div >
        <PageHeader>
            <template #navbar>
                <Navbar />
            </template>
            <template #pagetitle>
                <PageTitle
                    :pageTitle="$t('pages.titles.productThree')"
                    :pageParentTitle="$t('pages.parents.products')"
                />
            </template>
        </PageHeader>
        <About />
        <AboutReverse />
        <AboutReverse2 />

        <About2 />
        <FreeTrial variant="light"/>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageHeader from '../Layout/PageHeader'
import FreeTrial from '../Common/FreeTrial'
import PageTitle from '../Common/PageTitle'
import AboutReverse2 from '../Product/Three/AboutReverse2'
import About2 from '../Product/Three/About2'
import Footer from '../Layout/Footer'
import AboutReverse from '../Product/Three/AboutReverse'
import About from '../Product/Three/About'



export default {
    name: 'SearchPage',
    components: {
        Navbar,
        PageTitle,
        PageHeader,
        FreeTrial,
        Footer,
        AboutReverse,
        About,
        AboutReverse2,
        About2,
    }
}
</script>
